import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import {
  convertDBDate,
  membershipApplicationStatisticscardData
} from "./common";
import AddMembershipApplicationComponent from "./AddMembershipApplicationComponent";
import ViewMembershipApplicationComponent from "./ViewMembershipApplicationComponent";
import { baseUrl, ROUTE_BASE_URL } from "../../api/common";
import axios from "axios";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import { FormCheck } from "react-bootstrap";
import { useUser } from '../AdminUsers/UserContext';

const MembershipApplicationDetailsStatus = () => {

  const { slug } = useParams();
  const pathSegments = window.location.pathname.split("/");
  const memberApplicationType = pathSegments[3];
  const { checkPermission } = useUser();
  const [addPopupStatus, setaddPopupStatus] = useState(false);

  const [eventType, setEventType] = useState("");
  const [updateId, setUpdateId] = useState("");

  const handleAddPopup = async(status, type, memberId) => {
    setEventType(type);
    setUpdateId(memberId);
    console.log('memberId received:', memberId);
    if(type==="Update"){
      const hasPermission = await checkPermission("Membership Application", "update");
      if (!hasPermission) return;
    }
    setaddPopupStatus(status);    
  };

  // const [viewMemberDedails, setViewMemberDedails] = useState({
  //     sno: '',
  //     name: '',
  //     applicationid: '',
  //     email: '',
  //     Memberlist: '',
  //     year: '',
  //     memberid: '',
  //     status: '',
  //     amount: '',
  //     date: '',
  // });

  const [viewPopupStatus, setViewPopupStatus] = useState(false);
  const [viewMemberId, setViewMemberId] = useState("");

  const handleViewMemberPopup = (status, memberId) => {
    setViewMemberId(memberId);
    setViewPopupStatus(status);
  };

  const [applicationMembersData, setApplicationMembersData] = useState([]);
  const membersTableData = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        attributes: {
          style: { width: "4%" },
        },
      },
      {
        label: "Name",
        field: "name",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "12%" },
        },
      },
      {
        label: "Application No",
        field: "application_no",
        sort: "disabled",
        // width: 100,
        attributes: {
          style: { width: "8%" },
        },
      },
      {
        label: "Member ID",
        field: "memberid",
        sort: "disabled",
        // width: 150,
        attributes: {
          style: { width: "8%" },
        },
      },
      {
        label: "Mobile",
        field: "mobile",
        sort: "asc",
        // width: 100,
        attributes: {
          style: { width: "10%" },
        },
      },
      {
        label: "Email",
        field: "email",
        // width: 200,
        attributes: {
          style: { width: "10%" },
        },
      },
      {
        label: "Status",
        field: "status",
        // width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "8%" },
        },
      },
      {
        label: "Application Date",
        field: "date",
        // width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "10%" },
        },
      },
      {
        label: "Login Activity",
        field: "login_activity",
        // width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "10%" },
        },
      },
    ],

    rows:
      applicationMembersData &&
      applicationMembersData.map((data, index) => ({
        sno: index + 1,
        // name: `${data.first_name} ${data.last_name}` || "N/A",
        name:data.salutation || data.first_name || data.middle_name || data.last_name
          ? `${data.salutation || ""} ${data.first_name || ""} ${data.middle_name || ""} ${data.last_name || ""}`
              .trim()
              .replace(/\s+/g, " ")
          : "N/A",
        applicationid: data.application_id || "N/A",
        email: data.email || "N/A",
        // Memberlist:data.application_id || "N/A",
        mobile: data.mobile || "N/A",
        memberid: data.membership_no || "N/A",
        application_no: data.application_no || "N/A",
        status: <span className="text-blue">{data.status_name || "N/A"}</span>,
        date: convertDBDate(data.member_reg_date) || "N/A",
        // login_activity: data.status_name || "N/A",
        login_activity: data.last_login ||"--",
        clickEvent: () => handleViewMemberPopup(true, data.id),
      }))
  };

  const fetchApplicationMembersData = async (id) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_member`,
        {
          application_id: id,
          application_status: slug !== "1" ? slug : ""
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        setApplicationMembersData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  // const [membershipApplicationData, setMembershipApplicationData] = useState ([]);
  const [applicationId, setApplicationId] = useState();
  const [applicationName, setApplicationName] = useState("");
  const [applicationStatusName, setApplicationStatusName] = useState("");
  const fetchMembershipApplicationData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_application`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        const details = response.data.data.find((item) => item.slug === memberApplicationType);
        const applicationStatus = membershipApplicationStatisticscardData.find((item) => `${item.id}` === slug);
        console.log(applicationStatus, "applicationStatus");
        setApplicationId(details.id);
        setApplicationName(details.application_name);
        fetchApplicationMembersData(details.id);
        setApplicationStatusName(applicationStatus.title);
        // setMembershipApplicationData (response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const [changeStatusFormValues, setChangeStatusFormValues] = useState({
    message: "",
    password: "",
  });

  const [changeStatusErrors, setchangeStatusErrors] = useState({
    message: "",
    password: "",
  });

  const handleInputChange = (field, value) => {
    setChangeStatusFormValues({ ...changeStatusFormValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
      message: "",
      password: "",
    };
    if (!changeStatusFormValues.message.trim()) {
      newErrors.message = "Message cannot be empty";
    }
    if (!changeStatusFormValues.password.trim()) {
      newErrors.password = "Password cannot be empty";
    }
    setchangeStatusErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const clearInputValues = () => {
    setchangeStatusErrors({
      message: "",
      password: "",
    });
    setChangeStatusFormValues({
      message: "",
      password: "",
    });
    handleChangeStatusModal(false, "", "");
    handleViewMemberPopup(false);
  };

  const [selectedPaymentId, setSelectedPaymentId] = useState(null);

  const [applicationPaymentAmount, setApplicationPaymentAmount] = useState("");
  const [applicationPaymentDate, setApplicationPaymentDate] = useState("");
  const [applicationPaymentNarration, setApplicationPaymentNarration] = useState("");
  const [applicationStatus, setApplicationStatus] = useState("");
  const [applicationStatusId, setApplicationStatusId] = useState("");
  const [openChangeStatusModal, setOpenChangeStatusModal] = useState(false);
  const [openApproveStatusModal, setOpenApproveStatusModal] = useState(false);

  const [offlinePaymentErrors, setOfflinePaymentErrors] = useState({
    amount: "",
    date: "",
    narration: ""
  });

  const handlePaymentIdChange = (id) => {
    setSelectedPaymentId(id);
    setOfflinePaymentErrors({ amount: "", date: "", narration: "" }); // Reset errors on change
  };

  const offlineValidate = () => {
    const newErrors = {
      amount: "",
      date: "",
      narration: ""
    };

    if (!applicationPaymentAmount.trim() || !applicationPaymentDate || !applicationPaymentNarration.trim()) {
      newErrors.amount = "Amount/Date/Narration cannot be empty";
      newErrors.date = "Amount/Date/Narration cannot be empty";
      newErrors.narration = "Amount/Date/Narration cannot be empty";
    }
    // if (!applicationPaymentDate) {
    //   newErrors.date = "Date cannot be empty";
    // }
    // if (!applicationPaymentNarration.trim()) {
    //   newErrors.narration = "Narration cannot be empty";
    // }
    setOfflinePaymentErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const clearOfflineInputValues = () => {
    setOfflinePaymentErrors({
      amount: "",
      date: "",
      narration: ""
    });
    setSelectedPaymentId(null);
    setApplicationPaymentNarration("");
    setApplicationPaymentDate("");
    setApplicationPaymentAmount("");
    setOpenApproveStatusModal(false);
    handleViewMemberPopup(false);
  };

  const handleApproveStatusModal = () => {
    setOfflinePaymentErrors({
      amount: "",
      date: "",
      narration: ""
    });
    setSelectedPaymentId(null);
    setApplicationPaymentNarration("");
    setApplicationPaymentDate("");
    setApplicationPaymentAmount("");
    setOpenApproveStatusModal(false);
  }

  const handleChangeStatusModal = (status, id, applicationStatus) => {
    setApplicationStatus(applicationStatus);
    setApplicationStatusId(id);
    setOpenChangeStatusModal(status);
    // if (id === 1|| id === 11) {
    //   setOpenApproveStatusModal(status);
    // } else {
    //   setOpenChangeStatusModal(status);
    // }
  };

  const handleChangeApplicationStatus = async () => {
    if (validate()) {
      console.log(
        {
          ...changeStatusFormValues,
          member_id: viewMemberId,
          application_status: applicationStatusId,
          login_user_id: localStorage.getItem("loginUserId"),
        },
        "handleChangeApplicationStatus"
      );
      try {
        const response = await axios.post(
          `${baseUrl}/api/member_activity_update`,
          {
            ...changeStatusFormValues,
            member_id: viewMemberId,
            application_status: applicationStatusId,
            login_user_id: localStorage.getItem("loginUserId"),
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("access_token"),
            },
          }
        );
        if (response.data.status) {
          console.log(response.data, "response.data");
          showToast(response.data.message, "success");
          fetchMembershipApplicationData();
          clearInputValues();
        } else {
          console.error("Error: Failed to fetch user data");
          showToast(response.data.message, "error");
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    }
  };

  const handleApproveApplicationStatus = async () => {
    if (selectedPaymentId) {
      if (selectedPaymentId === 2) {
        if (!offlineValidate()) return;
      }
      console.log(
        {
          ...changeStatusFormValues,
          member_id: viewMemberId,
          application_status: applicationStatusId,
          login_user_id: localStorage.getItem("loginUserId"),
          amount: applicationPaymentAmount,
          payment_method: selectedPaymentId,
          payed_date: applicationPaymentDate,
          narration: applicationPaymentNarration
        },
        "handleChangeApplicationStatus"
      );
      try {
        const response = await axios.post(
          `${baseUrl}/api/create_payment_link`,
          {
            ...changeStatusFormValues,
            member_id: viewMemberId,
            application_status: applicationStatusId,
            login_user_id: localStorage.getItem("loginUserId"),
            amount: applicationPaymentAmount,
            payment_method: selectedPaymentId,
            payed_date: applicationPaymentDate,
            narration: applicationPaymentNarration
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("access_token"),
            },
          }
        );
        if (response.data.status) {
          console.log(response.data, "response.data");
          showToast(response.data.message, "success");
          fetchMembershipApplicationData();
          clearOfflineInputValues();
        } else {
          console.error("Error: Failed to fetch user data");
          showToast(response.data.message, "error");
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    } else {
      showToast("Plese Choose a Payment Type", "error");
    }
  };

  const [paymentTypeData, setPaymentTypeData] = useState([]);
  const fetchPaymentTypeData = async (id) => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_payment_method`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });
      if (response.data.status) {
        setPaymentTypeData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  useEffect(() => {
    fetchPaymentTypeData();
    fetchMembershipApplicationData();
    console.log(memberApplicationType);
  }, []);

  return (
    <>
      <ToastMessage />
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-8 col-sm-12">
              {/* {membershipApplicationData.length > 0 && slug && (
                            <h1>{getMembershipApplicationName(slug)}</h1>
               )} */}
              {applicationStatusName}
              {/* <h1>{membershipApplicationData&&getMembershipApplicationName(slug)}</h1> */}
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`${ROUTE_BASE_URL}/membership-application`}>
                      Membership Application
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`${ROUTE_BASE_URL}/membership-application/${memberApplicationType}`}>
                      {applicationName}
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {/* {membershipApplicationData&&getMembershipApplicationName(slug)} */}
                    {/* {membershipApplicationData.length > 0 && slug && (
                         getMembershipApplicationName(slug)
                    )} */}
                    {applicationStatusName}
                  </li>
                </ol>
              </nav>
            </div>
            {/* <div className="col-md-4 col-sm-12 text-right hidden-xs">
              <span
                onClick={() => handleAddPopup(true, "Add", "")}
                className="btn btn-outline-primary mr-1"
                title=""
              >
                Add New
              </span>
            </div> */}
          </div>
        </div>

        <div className="row clearfix table_scrool">
          <div className="col-lg-12">
            <div className="card">
              <div className="body">
                <div className="table-responsive">
                  <MDBDataTable
                    noBottomColumns
                    className="table table-hover js-basic-example dataTable table-custom spacing5"
                    entriesOptions={[5, 10, 20, 25]}
                    entries={10}
                    paging
                    pagesAmount={5}
                    data={membersTableData}
                    sortRows={["title"]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ------add member component--------- */}
        <AddMembershipApplicationComponent
          memberId={updateId}
          eventType={eventType}
          fetchApplicationMembersData={fetchApplicationMembersData}
          memberApplicationId={applicationId}
          addPopupStatus={addPopupStatus}
          handleAddPopup={handleAddPopup}
        />
        {/* ------------------------- */}

        {/* ------view member component--------- */}
        <ViewMembershipApplicationComponent
          handleChangeStatusModal={handleChangeStatusModal}
          applicationName={applicationName}
          fetchApplicationMembersData={fetchApplicationMembersData}
          memberId={viewMemberId}
          viewPopupStatus={viewPopupStatus}
          handleAddPopup={handleAddPopup}
          handleViewMemberPopup={handleViewMemberPopup}
        />
        {/* ------------------------- */}

        {/* ------Change Application Status--------- */}
        {openChangeStatusModal && (
          <div className="modal fade d-block show">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Change Status</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => handleChangeStatusModal(false, "", "")}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="d-flex mb-3">
                    <div>
                      <h6 className="mb-0">
                        Would you like to change the application status to "{applicationStatus}"?
                      </h6>
                    </div>
                  </div>
                  <div className="form-group pos_relative">
                    <label>Enter Your Password</label>
                    {/* <input type="text" className="form-control" required /> */}
                    <input
                      type="text"
                      className={`form-control ${changeStatusErrors.password ? "red_border" : ""
                        }`}
                      value={changeStatusFormValues.password}
                      onChange={(e) =>
                        handleInputChange("password", e.target.value)
                      }
                    />
                    {changeStatusErrors && (
                      <p className="text-danger pos_abos">
                        {changeStatusErrors.password}
                      </p>
                    )}
                  </div>
                  <div className="form-group pos_relative">
                    <label>Message Here</label>
                    <textarea
                      rows={4}
                      type="text"
                      className={`form-control ${changeStatusErrors.message ? "red_border" : ""
                        }`}
                      value={changeStatusFormValues.message}
                      onChange={(e) =>
                        handleInputChange("message", e.target.value)
                      }
                    />
                    {changeStatusErrors && (
                      <p className="text-danger pos_abos">
                        {changeStatusErrors.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-default	"
                    onClick={() => handleChangeStatusModal(false, "", "")}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleChangeApplicationStatus}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* ------------------------- */}
        {/* ------Approve Status--------- */}
        {openApproveStatusModal && (
          <div className="modal fade d-block show">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Change Status</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => handleApproveStatusModal()}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="d-flex mb-3">
                    <div>
                      <h6 className="mb-0">Choose a Payment Type</h6>
                    </div>
                  </div>
                  <div className="form-group pos_relative">
                    <div className="col-lg-12 col-md-12">
                      <div className="check_grid">
                        {paymentTypeData.map((data) => (
                          <div key={data.id}>
                            <FormCheck
                              type="checkbox"
                              id={`checkbox-${data.id}`}
                              label={data.payment_name}
                              checked={selectedPaymentId === data.id}
                              onChange={() => handlePaymentIdChange(data.id)}
                            />
                          </div>
                        ))}
                      </div>
                      {selectedPaymentId === 2 && (
                        <div className="col-lg-12 col-md-12">
                          <div className="row pt-4">
                            <div className="col-lg-4 col-md-4 p-i-0 pos_relative">
                              <input
                                type="number"
                                className={`form-control ${offlinePaymentErrors.amount
                                    ? "red_border"
                                    : ""
                                  }`}
                                placeholder="Amount Paid"
                                value={applicationPaymentAmount}
                                onChange={(e) =>
                                  setApplicationPaymentAmount(e.target.value)
                                }
                              />
                              {offlinePaymentErrors && (
                                <p className="text-danger pos_abos white_space">
                                  {offlinePaymentErrors.amount}
                                </p>
                              )}
                            </div>
                            <div className="col-lg-4 col-md-4 p-i-0 pos_relative">
                              <input
                                type="date"
                                className={`form-control ${offlinePaymentErrors.date
                                    ? "red_border"
                                    : ""
                                  }`}
                                onClick={(e) => e.target.showPicker()}
                                placeholder="Date"
                                // value={applicationPaymentDate ? dayjs(applicationPaymentDate).format(dateFormatList) : ""}
                                value={applicationPaymentDate}
                                onChange={(e) =>
                                  setApplicationPaymentDate(e.target.value)
                                }
                              />
                              {/* {offlinePaymentErrors && (
                                <p className="text-danger pos_abos">
                                  {offlinePaymentErrors.date}
                                </p>
                              )} */}
                            </div>
                            <div className="col-lg-4 col-md-4 p-i-0">
                              <div className="form-group pos_relative">
                                <input
                                  type="text"
                                  className={`form-control ${offlinePaymentErrors.narration
                                      ? "red_border"
                                      : ""
                                    }`}
                                  placeholder="Narration"
                                  value={applicationPaymentNarration}
                                  onChange={(e) =>
                                    setApplicationPaymentNarration(e.target.value)
                                  }
                                />
                                {/* {offlinePaymentErrors && (
                                <p className="text-danger pos_abos">
                                  {offlinePaymentErrors.narration}
                                </p>
                              )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => handleApproveStatusModal()}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleApproveApplicationStatus}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* ------------------------- */}
      </div>
    </>
  );
};
export default MembershipApplicationDetailsStatus;
